import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Divider, Row, theme } from 'antd';

interface JobSlotDetailProps {
  detail?: string;
  detailsList?: string[];
  icon: IconDefinition;
  showDivider?: boolean;
  dividerWidth?: string;
  fontWeight?: 'strong' | 'normal';
}

export const JobSlotDetail = ({
  detail,
  detailsList,
  icon,
  showDivider = true,
  dividerWidth,
  fontWeight,
}: JobSlotDetailProps) => {
  const { token } = theme.useToken();

  return (
    <>
      <Row
        align="top"
        gutter={token.marginSM}
        style={{
          flexFlow: 'row',
        }}
      >
        <Col style={{ minWidth: 20 }}>
          <FontAwesomeIcon icon={icon} style={{ fontSize: token.fontSizeLG }} />
        </Col>
        <Col
          style={{
            fontWeight:
              fontWeight === 'strong' ? token.fontWeightStrong : 'normal',
            fontSize: token.fontSizeSM,
            alignSelf: 'center',
          }}
        >
          {detail && detail}
          {detailsList && (
            <Row wrap gutter={token.marginSM}>
              {detailsList.map((detail) => {
                return (
                  <Col
                    key={detail}
                    style={{
                      fontSize: token.fontSizeSM,
                    }}
                  >
                    {detail}
                  </Col>
                );
              })}
            </Row>
          )}
        </Col>
      </Row>
      {showDivider && (
        <Divider
          style={{
            margin: '7px 0',
            minWidth: 0,
            width: dividerWidth ?? '100%',
          }}
        />
      )}
    </>
  );
};
